import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { CollaborationReadApiClient, People } from '~/services/Http';

export const GET_TASK_COMMENTS_SWR_KEY =
  'CollaborationReadApiClient.getTaskComments';

export function useGetTaskComments(args: {
  taskId: number;
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order9;
}): UseSWROutput<People.TaskCommentDto[]> {
  return useSWR(
    [
      GET_TASK_COMMENTS_SWR_KEY,
      args.taskId,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
    ],
    ([_, taskId, lang, offset, limit, order]) =>
      CollaborationReadApiClient.getTaskComments(
        taskId,
        order,
        offset,
        limit,
        lang,
      ).then((r) => r.data),
  );
}
